<template>
	<div class="map-wrapper">
		<div  class="content">
			<div id="map"></div>
		</div>
	</div>
</template>

<script>
	import { Loader } from "@googlemaps/js-api-loader"

	import { debounce } from 'lodash'

	export default {
		props: {
			googleMapKey: {
				required: true,
				type: String
			}
		},

		data() {
			return {
				zoom: 15,
				center: {lat: 51.5138508, lng: -0.1365678},
				styles: [
					{
						"featureType": "all",
						"elementType": "all",
						"stylers": [
							{
								"hue": "#ff0000"
							},
							{
								"saturation": -100
							},
							{
								"lightness": -30
							}
						]
					},
					{
						"featureType": "all",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#ffffff"
							}
						]
					},
					{
						"featureType": "all",
						"elementType": "labels.text.stroke",
						"stylers": [
							{
								"color": "#353535"
							}
						]
					},
					{
						"featureType": "landscape",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#656565"
							}
						]
					},
					{
						"featureType": "poi",
						"elementType": "geometry.fill",
						"stylers": [
							{
								"color": "#505050"
							}
						]
					},
					{
						"featureType": "poi",
						"elementType": "geometry.stroke",
						"stylers": [
							{
								"color": "#808080"
							}
						]
					},
					{
						"featureType": "road",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#454545"
							}
						]
					}
				]
			}
		},

		mounted() {
			this.initMap()
		},

		methods: {
			async initMap() {
				const loader = new Loader({
					apiKey: this.googleMapKey,
					version: "weekly",
				});

				loader.load().then(async () => {
					const { Map } = await google.maps.importLibrary("maps");
					const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

					const map = new Map(document.getElementById("map"), {
						center: this.center,
						zoom: this.zoom,
						disableDefaultUI: true,
						mapId: 'c27ff5342cbe7b14',
						//styles: this.styles
					});

					const markerImg = document.createElement("img");
						markerImg.src = '/img/BC-marker.png';

					const marker = new AdvancedMarkerElement({
						map: map,
						content: markerImg,
						draggable: true,
						position: this.center
					});

					window.addEventListener('resize', debounce(() => {						
						map.setCenter(this.center)
					}))
				})
			}
		}
	}

</script>
